import { Link } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";
import { useFavorites } from "@/hooks/useFavorites";
import { getAllVideos } from "@/utils/videoHelpers";
import VideoCard from "@/components/feature/VideoCard";

export default function FavoritesPage() {
  usePageMeta({
    title: "我的收藏-91短视频",
    description:
      "查看你在91短视频收藏的热门短视频，随时回顾喜欢的搞笑、娱乐、生活、美食内容。",
    keywords: "91短视频收藏,我的收藏,短视频收藏",
  });

  const { favoriteIds, removeFavorite } = useFavorites();
  const all = getAllVideos();
  const favoriteVideos = favoriteIds
    .map((id) => all.find((video) => video.id === id))
    .filter((video): video is (typeof all)[number] => Boolean(video));

  return (
    <div className="mx-auto w-full max-w-7xl px-4 py-8 md:px-6 md:py-10">
      <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
        <h1 className="flex items-center gap-2 text-lg font-bold text-foreground-900 md:text-xl">
          <i className="ri-heart-3-line text-xl text-accent-500"></i>
          我的收藏
        </h1>
        <p className="mt-1 text-sm text-foreground-500">
          共收藏 <span className="font-semibold text-foreground-800">{favoriteVideos.length}</span>{" "}
          个视频 · 收藏数据保存在本浏览器，仅用于演示
        </p>
      </div>

      {favoriteVideos.length === 0 ? (
        <div className="mt-6 flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 px-4 py-24 text-center">
          <i className="ri-heart-add-line text-5xl text-foreground-300"></i>
          <h2 className="mt-4 text-base font-semibold text-foreground-800">还没有收藏任何视频</h2>
          <p className="mt-2 max-w-sm text-sm text-foreground-500">
            浏览视频时点击封面上的爱心，就能把它收藏到这里，方便下次观看。
          </p>
          <Link
            to="/"
            className="mt-5 cursor-pointer rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition hover:bg-primary-600"
          >
            去发现热门视频
          </Link>
        </div>
      ) : (
        <div className="mt-5 grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-5 lg:grid-cols-4">
          {favoriteVideos.map((video) => (
            <div key={video.id} className="relative">
              <VideoCard video={video} />
              <button
                type="button"
                onClick={() => removeFavorite(video.id)}
                aria-label="移除收藏"
                title="移除收藏"
                className="absolute left-2 top-2 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-foreground-950/55 text-background-50 backdrop-blur transition hover:bg-accent-500"
              >
                <i className="ri-delete-bin-line text-base"></i>
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}